import React from "react";
import ListIndustry from "../../../containers/Settings/Industry/index";
const SettingIndustry = () => {
  return <ListIndustry />;
};
export default SettingIndustry;
